import { defineRecipe } from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
    variants: {
        variant: {
            plain: {
                bg: "transparent",
                color: "gray.800",
                fontWeight: "semibold",
                _hover: {
                    bg: "transparent",
                },
            },
            solid: {
                // bg: "gray.100",
                // color: "gray.800",
                fontWeight: "semibold",
                // _hover: {
                //     bg: "gray.200"
                // }
            },
            subtle: {
                // bg: "gray.100",
                // color: "gray.800",
                fontWeight: "semibold",
            },
            successLight: {
                bg: "green.50",
                borderColor: "green.100",
                borderWidth: "1px",
                color: "green.600",
                fontWeight: "normal",
            },
            successOutline: {
                borderColor: "green.100",
                borderWidth: "1px",
                color: "green.600",
                fontWeight: "normal",
            },
            light: {
                bg: "white",
                color: "blue.600",
                borderColor: "gray.200",
                borderWidth: "1px",
                fontWeight: "normal",
                _hover: {
                    bg: "gray.100",
                },
            },
            infoLight: {
                bg: "blue.50",
                borderColor: "blue.400",
                borderWidth: "1px",
                color: "blue.600",
                fontWeight: "normal",
            },
            neutralLight: {
                bg: "gray.50",
                color: "gray.600",
            },
            dangerLight: {
                bg: "red.50",
                color: "red.600",
            },
            link: {
                color: "blue.500",
                fontWeight: "normal",
            },
            outline: {
                fontWeight: "normal",
                colorPalette: "grey",
            },
            tertiary: {
                borderColor: "gray.300",
                colorPalette: "gray",
                fontSize: "xs",
                fontWeight: "medium",
            },
        },
    },
    defaultVariants: {
        variant: "outline",
    },
});
